{
  "name": "Practice weekly backgrounds",
  "brand": "Lab 10",
  "version": 1,
  "rotation": "iso-week",
  "width": 1717,
  "height": 916,
  "aspectRatio": "1.8745:1",
  "weeks": [
    {
      "week": 1,
      "name": "Quiet Coast",
      "slug": "quiet-coast",
      "light": "01-quiet-coast-light.webp",
      "dark": "01-quiet-coast-dark.webp"
    },
    {
      "week": 2,
      "name": "Frosted Marsh",
      "slug": "frosted-marsh",
      "light": "02-frosted-marsh-light.webp",
      "dark": "02-frosted-marsh-dark.webp"
    },
    {
      "week": 3,
      "name": "Snow Ridge",
      "slug": "snow-ridge",
      "light": "03-snow-ridge-light.webp",
      "dark": "03-snow-ridge-dark.webp"
    },
    {
      "week": 4,
      "name": "Mist Pines",
      "slug": "mist-pines",
      "light": "04-mist-pines-light.webp",
      "dark": "04-mist-pines-dark.webp"
    },
    {
      "week": 5,
      "name": "Ice Shelf",
      "slug": "ice-shelf",
      "light": "05-ice-shelf-light.webp",
      "dark": "05-ice-shelf-dark.webp"
    },
    {
      "week": 6,
      "name": "Winter Dunes",
      "slug": "winter-dunes",
      "light": "06-winter-dunes-light.webp",
      "dark": "06-winter-dunes-dark.webp"
    },
    {
      "week": 7,
      "name": "Reed Lagoon",
      "slug": "reed-lagoon",
      "light": "07-reed-lagoon-light.webp",
      "dark": "07-reed-lagoon-dark.webp"
    },
    {
      "week": 8,
      "name": "Basalt Inlet",
      "slug": "basalt-inlet",
      "light": "08-basalt-inlet-light.webp",
      "dark": "08-basalt-inlet-dark.webp"
    },
    {
      "week": 9,
      "name": "Cloud Valley",
      "slug": "cloud-valley",
      "light": "09-cloud-valley-light.webp",
      "dark": "09-cloud-valley-dark.webp"
    },
    {
      "week": 10,
      "name": "Thaw Stream",
      "slug": "thaw-stream",
      "light": "10-thaw-stream-light.webp",
      "dark": "10-thaw-stream-dark.webp"
    },
    {
      "week": 11,
      "name": "Birch Mist",
      "slug": "birch-mist",
      "light": "11-birch-mist-light.webp",
      "dark": "11-birch-mist-dark.webp"
    },
    {
      "week": 12,
      "name": "Tidal Mudflat",
      "slug": "tidal-mudflat",
      "light": "12-tidal-mudflat-light.webp",
      "dark": "12-tidal-mudflat-dark.webp"
    },
    {
      "week": 13,
      "name": "Chalk Cliffs",
      "slug": "chalk-cliffs",
      "light": "13-chalk-cliffs-light.webp",
      "dark": "13-chalk-cliffs-dark.webp"
    },
    {
      "week": 14,
      "name": "Rain Lake",
      "slug": "rain-lake",
      "light": "14-rain-lake-light.webp",
      "dark": "14-rain-lake-dark.webp"
    },
    {
      "week": 15,
      "name": "Moss Stones",
      "slug": "moss-stones",
      "light": "15-moss-stones-light.webp",
      "dark": "15-moss-stones-dark.webp"
    },
    {
      "week": 16,
      "name": "Spring Heath",
      "slug": "spring-heath",
      "light": "16-spring-heath-light.webp",
      "dark": "16-spring-heath-dark.webp"
    },
    {
      "week": 17,
      "name": "Fog Estuary",
      "slug": "fog-estuary",
      "light": "17-fog-estuary-light.webp",
      "dark": "17-fog-estuary-dark.webp"
    },
    {
      "week": 18,
      "name": "Dune Grass",
      "slug": "dune-grass",
      "light": "18-dune-grass-light.webp",
      "dark": "18-dune-grass-dark.webp"
    },
    {
      "week": 19,
      "name": "Limestone Basin",
      "slug": "limestone-basin",
      "light": "19-limestone-basin-light.webp",
      "dark": "19-limestone-basin-dark.webp"
    },
    {
      "week": 20,
      "name": "Alpine Tarn",
      "slug": "alpine-tarn",
      "light": "20-alpine-tarn-light.webp",
      "dark": "20-alpine-tarn-dark.webp"
    },
    {
      "week": 21,
      "name": "Wet Grassland",
      "slug": "wet-grassland",
      "light": "21-wet-grassland-light.webp",
      "dark": "21-wet-grassland-dark.webp"
    },
    {
      "week": 22,
      "name": "Silver Bay",
      "slug": "silver-bay",
      "light": "22-silver-bay-light.webp",
      "dark": "22-silver-bay-dark.webp"
    },
    {
      "week": 23,
      "name": "Desert Wash",
      "slug": "desert-wash",
      "light": "23-desert-wash-light.webp",
      "dark": "23-desert-wash-dark.webp"
    },
    {
      "week": 24,
      "name": "Salt Pan",
      "slug": "salt-pan",
      "light": "24-salt-pan-light.webp",
      "dark": "24-salt-pan-dark.webp"
    },
    {
      "week": 25,
      "name": "Sandstone Cove",
      "slug": "sandstone-cove",
      "light": "25-sandstone-cove-light.webp",
      "dark": "25-sandstone-cove-dark.webp"
    },
    {
      "week": 26,
      "name": "Sage Basin",
      "slug": "sage-basin",
      "light": "26-sage-basin-light.webp",
      "dark": "26-sage-basin-dark.webp"
    },
    {
      "week": 27,
      "name": "Lake Reeds",
      "slug": "lake-reeds",
      "light": "27-lake-reeds-light.webp",
      "dark": "27-lake-reeds-dark.webp"
    },
    {
      "week": 28,
      "name": "Granite Valley",
      "slug": "granite-valley",
      "light": "28-granite-valley-light.webp",
      "dark": "28-granite-valley-dark.webp"
    },
    {
      "week": 29,
      "name": "Fog Islands",
      "slug": "fog-islands",
      "light": "29-fog-islands-light.webp",
      "dark": "29-fog-islands-dark.webp"
    },
    {
      "week": 30,
      "name": "Summer Steppe",
      "slug": "summer-steppe",
      "light": "30-summer-steppe-light.webp",
      "dark": "30-summer-steppe-dark.webp"
    },
    {
      "week": 31,
      "name": "Dune Shadow",
      "slug": "dune-shadow",
      "light": "31-dune-shadow-light.webp",
      "dark": "31-dune-shadow-dark.webp"
    },
    {
      "week": 32,
      "name": "Still River",
      "slug": "still-river",
      "light": "32-still-river-light.webp",
      "dark": "32-still-river-dark.webp"
    },
    {
      "week": 33,
      "name": "Coastal Heath",
      "slug": "coastal-heath",
      "light": "33-coastal-heath-light.webp",
      "dark": "33-coastal-heath-dark.webp"
    },
    {
      "week": 34,
      "name": "Glacial Plain",
      "slug": "glacial-plain",
      "light": "34-glacial-plain-light.webp",
      "dark": "34-glacial-plain-dark.webp"
    },
    {
      "week": 35,
      "name": "Slate Shore",
      "slug": "slate-shore",
      "light": "35-slate-shore-light.webp",
      "dark": "35-slate-shore-dark.webp"
    },
    {
      "week": 36,
      "name": "Rain Desert",
      "slug": "rain-desert",
      "light": "36-rain-desert-light.webp",
      "dark": "36-rain-desert-dark.webp"
    },
    {
      "week": 37,
      "name": "River Stones",
      "slug": "river-stones",
      "light": "37-river-stones-light.webp",
      "dark": "37-river-stones-dark.webp"
    },
    {
      "week": 38,
      "name": "Amber Marsh",
      "slug": "amber-marsh",
      "light": "38-amber-marsh-light.webp",
      "dark": "38-amber-marsh-dark.webp"
    },
    {
      "week": 39,
      "name": "Cloud Steppe",
      "slug": "cloud-steppe",
      "light": "39-cloud-steppe-light.webp",
      "dark": "39-cloud-steppe-dark.webp"
    },
    {
      "week": 40,
      "name": "Granite Pools",
      "slug": "granite-pools",
      "light": "40-granite-pools-light.webp",
      "dark": "40-granite-pools-dark.webp"
    },
    {
      "week": 41,
      "name": "Autumn Reeds",
      "slug": "autumn-reeds",
      "light": "41-autumn-reeds-light.webp",
      "dark": "41-autumn-reeds-dark.webp"
    },
    {
      "week": 42,
      "name": "Fog Meadow",
      "slug": "fog-meadow",
      "light": "42-fog-meadow-light.webp",
      "dark": "42-fog-meadow-dark.webp"
    },
    {
      "week": 43,
      "name": "Copper Grass",
      "slug": "copper-grass",
      "light": "43-copper-grass-light.webp",
      "dark": "43-copper-grass-dark.webp"
    },
    {
      "week": 44,
      "name": "Stone Ravine",
      "slug": "stone-ravine",
      "light": "44-stone-ravine-light.webp",
      "dark": "44-stone-ravine-dark.webp"
    },
    {
      "week": 45,
      "name": "Mist Lake",
      "slug": "mist-lake",
      "light": "45-mist-lake-light.webp",
      "dark": "45-mist-lake-dark.webp"
    },
    {
      "week": 46,
      "name": "First Frost",
      "slug": "first-frost",
      "light": "46-first-frost-light.webp",
      "dark": "46-first-frost-dark.webp"
    },
    {
      "week": 47,
      "name": "Gray Dunes",
      "slug": "gray-dunes",
      "light": "47-gray-dunes-light.webp",
      "dark": "47-gray-dunes-dark.webp"
    },
    {
      "week": 48,
      "name": "Snow Marsh",
      "slug": "snow-marsh",
      "light": "48-snow-marsh-light.webp",
      "dark": "48-snow-marsh-dark.webp"
    },
    {
      "week": 49,
      "name": "Ice Lagoon",
      "slug": "ice-lagoon",
      "light": "49-ice-lagoon-light.webp",
      "dark": "49-ice-lagoon-dark.webp"
    },
    {
      "week": 50,
      "name": "Winter Heath",
      "slug": "winter-heath",
      "light": "50-winter-heath-light.webp",
      "dark": "50-winter-heath-dark.webp"
    },
    {
      "week": 51,
      "name": "Snow Basin",
      "slug": "snow-basin",
      "light": "51-snow-basin-light.webp",
      "dark": "51-snow-basin-dark.webp"
    },
    {
      "week": 52,
      "name": "Polar Twilight",
      "slug": "polar-twilight",
      "light": "52-polar-twilight-light.webp",
      "dark": "52-polar-twilight-dark.webp"
    }
  ]
}
